var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInviteIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80FA9A47-8590-4395-A030-24149CA01E90@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kitlfy-for-Business-Style-Guide_2",
    transform: "translate(-837.000000, -329.000000)",
    stroke: "#A1A1AD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Talent-Copy-4",
    transform: "translate(837.000000, 329.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-add",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.5 C6.676,12.5 4.171,13.138 2.525,13.693 C1.31,14.104 0.5,15.249 0.5,16.532 L0.5,20.5 C0.5,20.5 10.458,20.5 10.5,20.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.5 L9.5,12.5 C6.739,12.5 4.5,9.261 4.5,6.5 L4.5,5.5 C4.5,2.739 6.739,0.5 9.5,0.5 L9.5,0.5 C12.261,0.5 14.5,2.739 14.5,5.5 L14.5,6.5 C14.5,9.261 12.261,12.5 9.5,12.5 Z",
    id: "Path",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 15.5,
    x2: 17.5,
    y2: 21.5,
    id: "Path",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 18.5,
    x2: 20.5,
    y2: 18.5,
    id: "Path",
    strokeLinecap: "square"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIconGray);
export default __webpack_public_path__ + "static/media/InviteIconGray.01fa637ae35375ee59767645281d20a4.svg";
export { ForwardRef as ReactComponent };